export default "__VITE_ASSET__DFO9uSWB__"